var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAoAngola(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_7345)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 0H0V22.8375H60V0Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 22.1625H0V45H60V22.1625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.559 13.8938C23.0715 17.9531 33.0277 37.8563 45.2434 29.5688L46.0684 30.8438C38.8777 35.9625 31.7621 31.8375 29.7559 26.4938C27.6746 20.9813 30.4684 13.2281 38.4371 12.4313L38.559 13.8938Z",
    fill: "#FFEC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0623 31.0125L42.0279 31.9594L42.9842 34.0031L45.0186 33.0469L44.0623 31.0125ZM30.0936 21.6844H27.8436V23.9344H30.0936V21.6844ZM31.1904 18.0375L29.0998 17.2313L28.2842 19.3219L30.3748 20.1375L31.1904 18.0375ZM33.6279 15.3094L32.0248 13.725L30.4404 15.3187L32.0342 16.9031L33.6279 15.3094ZM36.0842 11.5781L33.9842 12.3656L34.7811 14.4656L36.8811 13.6781L36.0842 11.5781ZM30.3748 25.3125L28.2842 26.1469L29.1279 28.2281L31.2092 27.3938L30.3748 25.3125ZM36.9279 31.875L34.8654 31.0031L33.9748 33.0656L36.0373 33.9469L36.9279 31.875ZM40.6311 32.1375H38.3811V34.3875H40.6311V32.1375ZM36.7592 21.2625L38.6623 19.8563L40.5654 21.225L39.8154 19.0687L41.7186 17.6625H39.4217L38.6248 15.5438L37.8936 17.6719L35.5779 17.6437L37.4154 19.0781L36.7592 21.2719V21.2625Z",
    fill: "#FFEC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4998 32.475C28.6123 32.5125 29.0811 33.6375 29.4092 34.1812L29.0623 34.275C27.7873 34.725 27.1498 35.1375 26.6061 35.9156C26.4803 36.0381 26.3151 36.1119 26.14 36.124C25.9648 36.136 25.7911 36.0854 25.6498 35.9812C25.6498 35.9812 25.3873 35.8875 25.0498 35.5125C24.7686 35.0906 24.8436 34.7625 25.1811 34.4719C26.2123 33.7219 27.3279 33.1594 28.4998 32.475Z",
    fill: "#FFEE00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7533 34.95C25.7533 35.0582 25.7963 35.1619 25.8728 35.2384C25.9492 35.3149 26.053 35.3578 26.1611 35.3578C26.2693 35.3578 26.373 35.3149 26.4495 35.2384C26.526 35.1619 26.5689 35.0582 26.5689 34.95C26.5689 34.8431 26.5265 34.7406 26.4509 34.665C26.3753 34.5894 26.2727 34.5469 26.1658 34.5469C26.0589 34.5469 25.9564 34.5894 25.8808 34.665C25.8052 34.7406 25.7627 34.8431 25.7627 34.95H25.7533ZM27.7596 33.675C27.7596 33.7832 27.8025 33.8869 27.879 33.9634C27.9555 34.0399 28.0592 34.0828 28.1674 34.0828C28.2755 34.0828 28.3793 34.0399 28.4558 33.9634C28.5322 33.8869 28.5752 33.7832 28.5752 33.675C28.5752 33.5669 28.5322 33.4631 28.4558 33.3867C28.3793 33.3102 28.2755 33.2672 28.1674 33.2672C28.0592 33.2672 27.9555 33.3102 27.879 33.3867C27.8025 33.4631 27.7596 33.5669 27.7596 33.675ZM26.7377 34.3313C26.7377 34.4394 26.7807 34.5432 26.8571 34.6196C26.9336 34.6961 27.0373 34.7391 27.1455 34.7391C27.2537 34.7391 27.3574 34.6961 27.4339 34.6196C27.5104 34.5432 27.5533 34.4394 27.5533 34.3313C27.5533 34.2231 27.5104 34.1194 27.4339 34.0429C27.3574 33.9664 27.2537 33.9235 27.1455 33.9235C27.0373 33.9235 26.9336 33.9664 26.8571 34.0429C26.7807 34.1194 26.7377 34.2231 26.7377 34.3313Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5783 34.0969C33.572 31.8187 37.7626 29.3625 41.7658 27.0843C43.5189 25.9875 43.6033 23.9531 42.422 22.4062C42.3095 22.1906 42.1595 22.2375 42.1033 22.3594C41.9626 23.1094 41.5408 23.8875 41.0345 24.375C36.8794 26.9887 32.7633 29.664 28.6876 32.4C29.0064 32.9437 29.2501 33.5531 29.5783 34.0875V34.0969Z",
    fill: "#FFEE00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1377 28.6406L30.4689 30.1406L31.9689 31.8094L33.6377 30.3094L32.1377 28.6406Z",
    fill: "#FFEC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5675 25.5015L28.8487 32.5796L28.9941 32.8203L40.7129 25.7422L40.5675 25.5015ZM34.2355 28.3913L30.2887 30.9507L30.4417 31.1867L34.3886 28.6273L34.2355 28.3913ZM36.5573 30.0657L32.5354 32.3907L32.6762 32.6342L36.6981 30.3092L36.5573 30.0657Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_7345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAoAngola);
export default __webpack_public_path__ + "static/media/ao Angola.696eefff879e174e1090a24ee0380fed.svg";
export { ForwardRef as ReactComponent };